var map = {
	"./addform.svg": 81727,
	"./button.svg": 12326,
	"./cascader.svg": 71514,
	"./checkbox.svg": 43042,
	"./color.svg": 8446,
	"./component.svg": 2406,
	"./date-range.svg": 32568,
	"./date.svg": 46381,
	"./db.svg": 39457,
	"./design.svg": 58669,
	"./form.svg": 74062,
	"./input.svg": 1794,
	"./number.svg": 84247,
	"./password.svg": 46408,
	"./radio.svg": 73958,
	"./rate.svg": 380,
	"./rich-text.svg": 42937,
	"./row.svg": 35768,
	"./select.svg": 18919,
	"./slider.svg": 80354,
	"./switch.svg": 30868,
	"./table-wt.svg": 53155,
	"./table.svg": 3797,
	"./textarea.svg": 81753,
	"./time-range.svg": 52128,
	"./time.svg": 25537,
	"./tree.svg": 40964,
	"./upload.svg": 69794,
	"./view.svg": 52934,
	"./web.svg": 32549,
	"./yulan.svg": 10920
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87886;